

export const SCHEMEA_NS_KEY = "schemaTranslations";